// Initializing error handling needs to happen first.
import { initLogging } from './lib/error-handler';
initLogging();

import { CssBaseline } from '@material-ui/core';
import { ThemeProvider } from '@material-ui/core/styles';
import onwardTheme from './lib/onwardTheme';
import RootRouter from './navigation/RootRouter';
import { AIChatProvider } from 'contexts/ai-chat-context';
import AuthProvider from './contexts/auth-context';
import OnwardApolloProvider from './data/OnwardApolloProvider';
import { ProvideTracking } from './lib/analytics/Tracker';
import { LoadingProvider } from './components/layout/Loading';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { ToastProvider } from 'components/layout/Toast';
import RealtimeProvider from 'lib/RealtimeProvider';
import FhirClientProvider from './contexts/ehr-context';
import AIChat from './ai-chat/AIChat';

// pick a date util library
import DateFnsAdapter from '@date-io/date-fns';
import './App.css';
import { useEffect } from 'react';
import SessionProvider from './contexts/session-context';

function App() {
  useEffect(() => {
    const loaderContainer = document.getElementById('loader-container');
    if (loaderContainer) {
      loaderContainer.style.display = 'none';
    }
  }, []);

  return (
    <ThemeProvider theme={onwardTheme}>
      <CssBaseline />
      <AuthProvider>
        {/* depends on auth */}
        <ProvideTracking>
          {/* depends on auth to sign out on 401s */}
          <OnwardApolloProvider>
            <LoadingProvider>
              <SessionProvider>
                <MuiPickersUtilsProvider utils={DateFnsAdapter}>
                  {/* depends on auth for private routes */}
                  <RealtimeProvider>
                    <ToastProvider>
                      <FhirClientProvider>
                        <AIChatProvider>
                          <RootRouter />
                          <AIChat />
                        </AIChatProvider>
                      </FhirClientProvider>
                    </ToastProvider>
                  </RealtimeProvider>
                </MuiPickersUtilsProvider>
              </SessionProvider>
            </LoadingProvider>
          </OnwardApolloProvider>
        </ProvideTracking>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
